import { BrandDetail as BrandDetailComponent } from './BrandDetail.component';
import { connector } from './BrandDetail.connector';

export const BrandDetail = connector(BrandDetailComponent);
